import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  Stack,
  Typography,
  Chip,
  Button,
  Grid,
  Avatar,
} from "@mui/material";
import PageHeader from "./../../components/PageHeader";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { useParams } from "react-router-dom";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import PlaylistPlayIcon from "@mui/icons-material/PlaylistPlay";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import ReplyIcon from "@mui/icons-material/Reply";
import AreaGraph from "../../components/AreaGraph";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import BottomSheet from "../../components/BottomSheet";
import ApiService from "./../../services/api-service";
import Loader from "./../../components/Loader";
import PieChart from "../../components/PieChart";
import { Images } from "./../../assets/common";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useHistory } from "react-router-dom";
import ProfileMenu from "../../components/ProfileMenu";
import OutsideClickHandler from "react-outside-click-handler";
import Chips from "../../components/Chips";
import FaceIcon from "@mui/icons-material/Face";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import AnalyticsBtn from "../../components/AnalyticsBtn";
import Map from "../../components/Map";
import DougnutPieChart from "../../components/DougnutPieChart";
import "./index.scss";
import BarGraph from "../../components/BarGraph";
import AllMusicViews from "../../components/AllMusicViews";
import AllMusicTips from "../../components/AllMusicTips";
import MusicViews from "../../components/MusicViews";
import MusicTips from "../../components/MusicTips";
import AllmusicStreams from "../../components/AllMusicStreams";
import AllMusicFollow from "../../components/AllMusicFollow";
import MusicStreams from "../../components/MusicStreams";
import MusicFollow from "../../components/MusicFollow";
import { music } from "../../components/AnalyticsStats";
import { setLocationType } from "react-geocode";
import { useTranslation } from "react-i18next";
import { dropMenu, getErrorString } from "../../constants/function";
import notifier from "../../components/Notifier";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function LifetimeCount(main, padd, flex) {
  const { t } = useTranslation("common");
  const history = useHistory();
  const { tab, title, id } = useParams();
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);
  // const [lifeTimeCount, setLifetimeCount] = React.useState({});
  const [selectedId, setSelectedAlbum] = React.useState();
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const [selectedTime, setSelectedTime] = React.useState(t("dropMenu.m17"));
  const [selectedKey, setSlectedKey] = useState("m17");
  const [curatorTabData, setCuratorTabData] = useState({});
  const [musicId, setMusicId] = React.useState([]);
  const [index, setIndex] = React.useState(0);
  const [overallBtn, setOverallBtn] = useState({});
  const [location, setLocatio] = useState([]);
  const [graph, setGraph] = useState([]);
  const [gender, setGender] = useState([]);
  const [age, setAge] = useState([]);
  const [currency, setCurrency] = useState([]);
  // const musici = useContext(music);
  // console.log(musici, ":mi:");
  // console.log(overallBtn);
  // const getOverallBtnDetails = async (tab, range) => {
  //   try {
  //     // setLoading(true);
  //     const response = await ApiService.LIFEIME_VIEW_ANALYTICS(365);
  //     setOverallBtn(response["result"]);
  //     console.log(response);
  //   } catch (error) {
  //     setLoading(false);
  //   }
  // };
  const getOverallBtnDetails = async (range, value) => {
    try {
      setLoading(true);
      setOpen(false);
      value = value ? value : 0;
      getCount(value);
      const response = await ApiService.LIFEIME_VIEW_ANALYTICS(value);
      const location = [];
      response["result"]["locationClassification"].forEach((c) => {
        location.push({
          name: c.country,
          value1: c.count.toString(),
          value2: c.percentage.toString(),
          country: c.country,
        });
      });
      setLocatio([...location]);
      setGraph([...response["result"]["graph"]]);
      setGender([...response["result"]["genderClassification"]]);
      getAgeData("views", value);

      setLoading(false);
      // console.log(response, "::::::Main all response::::::");
      // console.log(graph, "::::::Main graph response::::::");
    } catch (error) {
      setLoading(false);
    }
  };

  const getOverallTipBtn = async (range, value) => {
    try {
      setLoading(true);
      setOpen(false);
      value = value ? value : 0;
      getCount(value);
      const response = await ApiService.LIFETIME_TIP_ANALYTICS(value);
      const location = [];
      response["result"]["locationClassification"].forEach((c) => {
        location.push({
          name: c.country,
          value1: c.count.toString(),
          value2: c.percentage.toString(),
          country: c.country,
        });
      });
      setLocatio([...location]);
      setGraph([...response["result"]["graph"]]);
      setGender([...response["result"]["genderClassification"]]);
      getAgeData("tips", value);
      setCurrency([...response["result"]["currencyClassification"]]);

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const getOverallStreamBtn = async (range, value) => {
    try {
      setLoading(true);
      setOpen(false);
      value = value ? value : 0;
      getCount(value);
      const response = await ApiService.LIFEIME_STREAM_ANALYTICS(value);
      const location = [];
      response["result"]["locationClassification"].forEach((c) => {
        location.push({
          name: c.country,
          value1: c.count.toString(),
          value2: c.percentage.toString(),
          country: c.country,
        });
      });
      setLocatio([...location]);
      setGraph([...response["result"]["graph"]]);
      setGender([...response["result"]["genderClassification"]]);
      getAgeData("listens", value);

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const getOverallFollowersBtn = async (range, value) => {
    try {
      setLoading(true);
      setOpen(false);
      value = value ? value : 0;
      getCount(value);
      const response = await ApiService.LIFEIME_FOLLOWERS_ANALYTICS(value);
      const location = [];
      response["result"]["locationClassification"].forEach((c) => {
        location.push({
          name: c.country,
          value1: c.count.toString(),
          value2: c.percentage.toString(),
          country: c.country,
        });
      });
      setLocatio([...location]);
      setGraph([...response["result"]["graph"]]);
      setGender([...response["result"]["genderClassification"]]);
      getAgeData("followers", value);

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getMuaicViews = async (range, value) => {
    try {
      setLoading(true);
      setOpen(false);
      value = value ? value : 0;
      getCount(value, id);
      const response = await ApiService.MUSIC_VIEW_ANALYTICS(
        `range=${value}&musicId=${id}`
      );
      const location = [];
      response["result"]["locationClassification"].forEach((c) => {
        location.push({
          name: c.country,
          value1: c.count.toString(),
          value2: c.percentage.toString(),
          country: c.country,
        });
      });
      setLocatio([...location]);
      setGraph([...response["result"]["graph"]]);
      setGender([...response["result"]["genderClassification"]]);
      getAgeData("views", value, id);

      // setMusicId(response.result.musicDetails);
      setMusicId({ ...response["result"]["musicDetails"] });
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const getMusicTips = async (range, value) => {
    try {
      setLoading(true);
      setOpen(false);
      value = value ? value : 0;
      getCount(value, id);
      const response = await ApiService.MUSIC_TIP_ANALYTICS(
        `range=${value}&musicId=${id}`
      );
      const location = [];
      response["result"]["locationClassification"].forEach((c) => {
        location.push({
          name: c.country,
          value1: c.count.toString(),
          value2: c.percentage.toString(),
          country: c.country,
        });
      });
      setLocatio([...location]);
      setGraph([...response["result"]["graph"]]);
      setGender([...response["result"]["genderClassification"]]);
      getAgeData("tips", value, id);
      setCurrency([...response["result"]["currencyClassification"]]);

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getMusicStreams = async (range, value) => {
    try {
      setLoading(true);
      setOpen(false);
      value = value ? value : 0;
      getCount(value, id);
      const response = await ApiService.MUSIC_STREAM_ANALYTICS(
        `range=${value}&musicId=${id}`
      );
      const location = [];
      response["result"]["locationClassification"].forEach((c) => {
        location.push({
          name: c.country,
          value1: c.count.toString(),
          value2: c.percentage.toString(),
          country: c.country,
        });
      });
      setLocatio([...location]);
      setGraph([...response["result"]["graph"]]);
      setGender([...response["result"]["genderClassification"]]);
      getAgeData("listens", value, id);

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getMusicFollows = async (range, value) => {
    try {
      setLoading(true);
      setOpen(false);
      value = value ? value : 0;
      getCount(value, id);
      const response = await ApiService.MUSIC_FOLLOW_ANALYTICS(
        `range=${value}&musicId=${id}`
      );
      const location = [];
      response["result"]["locationClassification"].forEach((c) => {
        location.push({
          name: c.country,
          value1: c.count.toString(),
          value2: c.percentage.toString(),
          country: c.country,
        });
      });
      setLocatio([...location]);
      setGraph([...response["result"]["graph"]]);
      setGender([...response["result"]["genderClassification"]]);
      getAgeData("followers", value, id);

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(
    (range) => {
      if (tab && !title) {
        switch (tab) {
          case "Views":
            getOverallBtnDetails(range);
            setIndex(0);
            setSelectedTime(t("dropMenu.m17"));
            setSlectedKey("m17");
            break;

          case "Tips":
            getOverallTipBtn(range);
            setIndex(3);
            setSelectedTime(t("dropMenu.m17"));
            setSlectedKey("m17");
            break;

          case "Streams":
            getOverallStreamBtn(range);
            setIndex(4);
            setSelectedTime(t("dropMenu.m17"));
            setSlectedKey("m17");
            break;

          case "Follow":
            getOverallFollowersBtn(range);
            setIndex(6);
            setSelectedTime(t("dropMenu.m17"));
            setSlectedKey("m17");
            break;

          default:
        }
      } else if (tab && title) {
        switch (tab) {
          case "Views":
            getMuaicViews(range);
            setIndex(0);
            setSelectedTime(t("dropMenu.m17"));
            setSlectedKey("m17");
            break;

          case "Tips":
            getMusicTips(range);
            setIndex(3);
            setSelectedTime(t("dropMenu.m17"));
            setSlectedKey("m17");
            break;

          case "Streams":
            getMusicStreams(range);
            setIndex(4);
            setSelectedTime(t("dropMenu.m17"));
            setSlectedKey("m17");
            break;

          case "Follow":
            getMusicFollows(range);
            setIndex(6);
            setSelectedTime(t("dropMenu.m17"));
            setSlectedKey("m17");
            break;

          default:
        }
      }
    },
    [tab, title]
  );

  const toggleDrawer = (newOpen, index) => {
    setOpen(newOpen);

    if (newOpen) {
      // console.log(newOpen, ":::::::newopen");
      const menu = dropMenu.filter((k) => k.key === newOpen);
      setSelectedTime(t(`dropMenu.${menu[0].key}`));
      setSlectedKey(menu[0].key);
      makeAction(newOpen);
    }
  };

  // const makeAction = (key) => {
  //   switch (key) {
  //     // case t("dropMenu.text17"):
  //     //   getLifetimeCount(value, 1000);
  //     //   break;
  //     case "Last 7 days":
  //       getLifetimeCount(value, 7);

  //       break;
  //     case "Last 28 days (4 weeks)":
  //       getLifetimeCount(value, 28);
  //       break;
  //     case "Last 365 days":
  //       getLifetimeCount(value, 365);
  //       break;
  //   }
  // };

  const makeAction = (key) => {
    if (tab && !title) {
      switch (key) {
        case "m17":
          if (tab && !title) {
            switch (tab) {
              case "Views":
                getOverallBtnDetails(value, 0);
                break;
              case "Tips":
                getOverallTipBtn(value, 0);
                break;
              case "Streams":
                getOverallStreamBtn(value, 0);
                break;
              case "Follow":
                getOverallFollowersBtn(value, 0);
                break;

              default:
            }
          }
          break;
        case "m18":
          if (tab && !title) {
            switch (tab) {
              case "Views":
                getOverallBtnDetails(value, 7);
                break;
              case "Tips":
                getOverallTipBtn(value, 7);
                break;
              case "Streams":
                getOverallStreamBtn(value, 7);
                break;
              case "Follow":
                getOverallFollowersBtn(value, 7);
                break;

              default:
            }
          }
          break;
        case "m19":
          if (tab && !title) {
            switch (tab) {
              case "Views":
                getOverallBtnDetails(value, 28);
                break;
              case "Tips":
                getOverallTipBtn(value, 28);
                break;
              case "Streams":
                getOverallStreamBtn(value, 28);
                break;
              case "Follow":
                getOverallFollowersBtn(value, 28);
                break;

              default:
            }
          }
          break;

        case "m20":
          if (tab && !title) {
            switch (tab) {
              case "Views":
                getOverallBtnDetails(value, 365);
                break;
              case "Tips":
                getOverallTipBtn(value, 365);
                break;
              case "Streams":
                getOverallStreamBtn(value, 365);
                break;
              case "Follow":
                getOverallFollowersBtn(value, 365);
                break;

              default:
            }
          }
          break;
      }
    } else {
      switch (key) {
        case "m17":
          if (tab && title) {
            switch (tab) {
              case "Views":
                getMuaicViews(value, 0);
                break;

              case "Tips":
                getMusicTips(value, 0);
                break;

              case "Streams":
                getMusicStreams(value, 0);
                break;

              case "Follow":
                getMusicFollows(value, 0);
                break;

              default:
              // getMuaicViews(0);
            }
          }
          break;

        case "m18":
          if (tab && title) {
            switch (tab) {
              case "Views":
                getMuaicViews(value, 7);
                break;

              case "Tips":
                getMusicTips(value, 7);
                break;

              case "Streams":
                getMusicStreams(value, 7);
                break;

              case "Follow":
                getMusicFollows(value, 7);
                break;

              default:
              // getMuaicViews(0);
            }
          }
          break;

        case "m19":
          if (tab && title) {
            switch (tab) {
              case "Views":
                getMuaicViews(value, 28);
                break;

              case "Tips":
                getMusicTips(value, 28);
                break;

              case "Streams":
                getMusicStreams(value, 28);
                break;

              case "Follow":
                getMusicFollows(value, 28);
                break;

              default:
              // getMuaicViews(0);
            }
          }
          break;

        case "m20":
          if (tab && title) {
            switch (tab) {
              case "Views":
                getMuaicViews(value, 365);
                break;

              case "Tips":
                getMusicTips(value, 365);
                break;

              case "Streams":
                getMusicStreams(value, 365);
                break;

              case "Follow":
                getMusicFollows(value, 365);
                break;

              default:
              // getMuaicViews(0);
            }
          }
          break;
      }
    }
  };

  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  //   setSelectedTime("Last 7 days");
  //   history.push(`/app/LifetimeCount/${newValue}/${title}`);
  //   getOverallBtnDetails(newValue, 1000);
  // };

  // const handleChangeIndex = (index) => {
  //   setValue(index);
  // };

  // const getLifetimeCount = async (tab, range) => {
  //   try {
  //     setLoading(true);
  //     setOpen(false);
  //     const respone =
  //       title === "curator"
  //         ? tab === 0
  //           ? await ApiService.LIFETIME_TIPS(range)
  //           : tab === 1
  //           ? await ApiService.LIFETIME_LISTEN(range)
  //           : tab === 2
  //           ? await ApiService.LIFETIME_SUBSCRIPTION(range)
  //           : tab === 3
  //           ? await ApiService.LIFETIME_OWNED(range)
  //           : tab === 4
  //           ? await ApiService.LIFETIME_PURCHASE(range)
  //           : tab === 5
  //           ? await ApiService.LIFETIME_PLAYLISTS(range)
  //           : await ApiService.LIFETIME_STREAMS(range)
  //         : title === "creator"
  //         ? tab === 0
  //           ? await ApiService.SONG_RELEASED(range)
  //           : tab === 1
  //           ? await ApiService.NFT_SOLD(range)
  //           : tab === 2
  //           ? await ApiService.CREATOR_STREAMS(range)
  //           : tab === 3
  //           ? await ApiService.PLAYLIST_ADD(range)
  //           : null
  //         : null;

  //     if (title === "curator") {
  //       getTabData(range);
  //     } else if (title === "creator") {
  //       getCreatorTabData(range);
  //     } else {
  //       setLoading(false);
  //     }
  //     setLifetimeCount({ ...respone["result"] });
  //   } catch (error) {
  //     setLoading(false);
  //     setOpen(false);
  //   }
  // };

  // const getCreatorTabData = async (range) => {
  //   try {
  //     const response = await ApiService.CREATOR_TAB_DATA(range);
  //     setCuratorTabData({ ...response["result"] });
  //     setLoading(false);
  //   } catch (e) {
  //     setLoading(false);
  //   }
  // };
  // const getTabData = async (range) => {
  //   try {
  //     const response = await ApiService.CURATOR_TAB_DATA(range);
  //     setCuratorTabData({ ...response["result"] });
  //     setLoading(false);
  //   } catch (e) {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   // const graph = lifeTimeCount;
  //   // graph["graph"] = [];
  //   // setLifetimeCount({ ...graph });
  //   // if (title === "curator") {
  //   //   switch (tab) {
  //   //     case "Tips":
  //   //       setValue(0);
  //   //       getLifetimeCount(0, 1000);
  //   //       break;
  //   //     case "Listens":
  //   //       setValue(1);
  //   //       getLifetimeCount(1, 1000);
  //   //       break;
  //   //     case "SubscribeMonthly":
  //   //       setValue(2);
  //   //       getLifetimeCount(2, 1000);
  //   //       break;
  //   //     case "NftOwned":
  //   //       setValue(3);
  //   //       getLifetimeCount(3, 1000);
  //   //       break;
  //   //     case "NftBuy":
  //   //       setValue(4);
  //   //       getLifetimeCount(4, 1000);
  //   //       break;
  //   //     case "PlaylistCreated":
  //   //       setValue(5);
  //   //       getLifetimeCount(5, 1000);
  //   //       break;
  //   //     case "PlaylistStreams":
  //   //       setValue(6);
  //   //       getLifetimeCount(6, 1000);
  //   //       break;
  //   //   }
  //   // } else if (title === "creator") {
  //   //   switch (tab) {
  //   //     case "SongReleased":
  //   //       setValue(0);
  //   //       getLifetimeCount(0, 1000);
  //   //       break;
  //   //     case "NftSold":
  //   //       // setValue(1);
  //   //       // getLifetimeCount(1, 1000);
  //   //       history.push(`/app/LifetimeCount/ad`);
  //   //       break;
  //   //     case "PlaylistAdd":
  //   //       setValue(2);
  //   //       getLifetimeCount(2, 1000);
  //   //       break;
  //   //     case "SongStreamed":
  //   //       setValue(3);
  //   //       getLifetimeCount(3, 1000);
  //   //       break;
  //   //   }
  //   // }
  //   if (tab && !title) {
  //     switch (tab) {
  //       case "Views":
  //         ApiService.LIFEIME_VIEW_ANALYTICS(value);
  //         break;
  //       case "Tips":
  //         ApiService.LIFETIME_TIP_ANALYTICS(value);
  //         break;
  //       case "Streams":
  //         ApiService.LIFEIME_STREAM_ANALYTICS(value);
  //         break;
  //       case "Follow":
  //         ApiService.LIFEIME_FOLLOWERS_ANALYTICS(value);
  //         break;

  //       default:
  //         break;
  //     }
  //   } else if (tab && title) {
  //     switch (tab) {
  //       case "Views":
  //         ApiService.MUSIC_VIEW_ANALYTICS(value);
  //         break;

  //       case "Tips":
  //         ApiService.MUSIC_TIP_ANALYTICS(value);
  //         break;

  //       case "Streams":
  //         ApiService.MUSIC_STREAM_ANALYTICS(value);
  //         break;

  //       case "Follow":
  //         ApiService.LIFEIME_FOLLOWERS_ANALYTICS(value);
  //         break;

  //       default:
  //         break;
  //     }
  //   }
  // }, []);
  const getAgeData = async (type, range, musicId) => {
    try {
      setLoading(true);
      const response = musicId
        ? await ApiService.AGE_GROUP(
            `type=${type}&range=${range}&musicId=${musicId}`
          )
        : await ApiService.AGE_GROUP(`type=${type}&range=${range}`);
      setAge([...response["result"]["ageClassification"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getCount = async (range, musicId) => {
    try {
      const response = await ApiService.COUNT(
        `range=${range}${musicId ? "&musicId=" + musicId : ""}`
      );
      setOverallBtn(response["result"]);
    } catch (error) {}
  };
  return (
    <Box className="main_width">
      <Box
        sx={{
          color: "#999999",
          display: "flex",
          alignItems: "center",
          padding: "0 20px 20px",
        }}
        className="_cp fs-14"
        // onClick={() => history.push("/app/Analytics")}
        onClick={() => history.goBack()}
      >
        <ArrowBackIosIcon className="fs-14" sx={{ color: "#999999" }} />{" "}
        {t("back")}
      </Box>
      <>
        {/* {title === "curator" ? (
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="full width tabs example"
          sx={{ padding: "0 10px", background: "#262626" }}
        >
          <Tab
            title="Tips"
            sx={{}}
            icon={
              <img
                style={{ marginRight: "8px" }}
                src={Images.handHolding}
                alt="tips"
              />
            }
            iconPosition="start"
            label={
              curatorTabData["tips"] ? curatorTabData["tips"].toFixed(4) : 0
            }
            {...a11yProps(0)}
          />
          <Tab
            title="Streams"
            icon={
              <img
                style={{ marginRight: "8px" }}
                src={Images.listen}
                alt="listens"
              />
            }
            iconPosition="start"
            label={curatorTabData["listens"] ? curatorTabData["listens"] : 0}
            {...a11yProps(1)}
          />
          <Tab
            title="Subscriptions"
            icon={
              <img
                style={{ marginRight: "8px" }}
                src={Images.user_add}
                alt="subs"
              />
            }
            iconPosition="start"
            label={
              curatorTabData["subscriptions"]
                ? curatorTabData["subscriptions"]
                : 0
            }
            {...a11yProps(2)}
          />

          <Tab
            title="NFT Owned"
            icon={
              <img
                style={{ marginRight: "8px" }}
                src={Images.nft_owned}
                alt="owned"
              />
            }
            iconPosition="start"
            label={curatorTabData["nftOwns"] ? curatorTabData["nftOwns"] : 0}
            {...a11yProps(3)}
          />
          <Tab
            title="NFT Purchased"
            icon={
              <img
                style={{ marginRight: "8px" }}
                src={Images.nft_buy}
                alt="owned"
              />
            }
            iconPosition="start"
            label={
              curatorTabData["purchasedNfts"]
                ? curatorTabData["purchasedNfts"]
                : 0
            }
            {...a11yProps(4)}
          />
          <Tab
            title="Playlist Created"
            icon={
              <img
                style={{ marginRight: "8px" }}
                src={Images.playlist_add}
                alt="owned"
              />
            }
            iconPosition="start"
            label={
              curatorTabData["createdPlaylists"]
                ? curatorTabData["createdPlaylists"]
                : 0
            }
            {...a11yProps(5)}
          />
          <Tab
            title="Playlist Streamed"
            icon={
              <img
                style={{ marginRight: "8px" }}
                src={Images.playlist}
                alt="owned"
              />
            }
            iconPosition="start"
            label={curatorTabData["streams"] ? curatorTabData["streams"] : 0}
            {...a11yProps(6)}
          />
        </Tabs>
      ) : (
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="full width tabs example"
          sx={{ padding: "0 10px", background: "#262626" }}
        >
          <Tab
            title="Song Released"
            sx={{}}
            icon={
              <img
                style={{ marginRight: "8px" }}
                src={Images.listen}
                alt="releasedSongs"
              />
            }
            iconPosition="start"
            label={
              curatorTabData["releasedSongsCount"]
                ? curatorTabData["releasedSongsCount"]
                : 0
            }
            {...a11yProps(0)}
          />
          <Tab
            title="NFT sell amount"
            icon={
              <img
                style={{ marginRight: "8px" }}
                src={Images.nft_amount}
                alt="nftSellAmount"
              />
            }
            iconPosition="start"
            label={
              curatorTabData["nftSoldCount"]
                ? curatorTabData["nftSoldCount"]
                : 0
            }
            {...a11yProps(1)}
          />
          <Tab
            title="Playlist added"
            icon={
              <img
                style={{ marginRight: "8px" }}
                src={Images.playlist_add}
                alt="totalPlaylistAdds"
              />
            }
            iconPosition="start"
            label={
              curatorTabData["playlistAddCount"]
                ? curatorTabData["playlistAddCount"]
                : 0
            }
            {...a11yProps(2)}
          />

          <Tab
            title="Song stream count"
            icon={
              <img
                style={{ marginRight: "8px" }}
                src={Images.playlist}
                alt="playlistStreamsCount"
              />
            }
            iconPosition="start"
            label={
              curatorTabData["streamsCount"]
                ? curatorTabData["streamsCount"]
                : 0
            }
            {...a11yProps(3)}
          />
        </Tabs>
      )} */}
      </>
      {tab && !title ? (
        <Typography className="web_header">
          {t("analytics.header.header1")}
        </Typography>
      ) : (
        <Stack
          className="web_header"
          sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
        >
          <Box sx={{ marginRight: "5px" }}>
            {musicId && (
              <Avatar
                sx={{ width: "24px", height: "24px" }}
                src={
                  musicId &&
                  musicId.thumbnailImg &&
                  musicId.thumbnailImg.filePath
                  // musicId?.thumbnailImg?.filePath
                }
              />
            )}
          </Box>
          <Typography variant="body1" className="fs-17">
            {title}
          </Typography>
        </Stack>
      )}
      {/* <Typography className="web_header">Lifetime Counts</Typography> */}
      <Stack
        direction="row"
        spacing={1}
        overflow="scroll"
        padding="15px 18px 0 18px"
        style={{
          top: "0",
          zIndex: "1",
          // backgroundColor: "#1e1e1e",
        }}
      >
        {/* <AnalyticsBtn
          index={0}
          activeIndex={index}
          onClick={(i) => setIndex(i)}
          view={overallBtn["views"]}
          title={overallBtn["views"]}
          history={(path) => {
            {
              // console.log(path, ":pp:");
            }
            history.push(
              `/app/LifetimeCount/${path}${title ? "/" + title + "/" + id : ""}`
            );
          }}
          image={index === 0 ? Images.black_views : Images.views_ico}
        /> */}
        {/* <AnalyticsBtn
          index={1}
          activeIndex={index}
          onClick={(i) => setIndex(i)}
          // like={overallBtn["like"]}
          history={(path) => {
            history.push(
              `/app/LifetimeCount/${path}${title ? "/" + title + "/" + id : ""}`
            );
          }}
          image={index === 1 ? Images.black_like : Images.like_ico}
        /> */}
        {/* <AnalyticsBtn
          index={2}
          activeIndex={index}
          onClick={(i) => setIndex(i)}
          // msg={overallBtn["msg"]}
          history={(path) => {
            history.push(
              `/app/LifetimeCount/${path}${title ? "/" + title + "/" + id : ""}`
            );
          }}
          image={index === 2 ? Images.black_msg : Images.msg_ico}
        /> */}
        <AnalyticsBtn
          index={3}
          activeIndex={index}
          onClick={(i) => setIndex(i)}
          tip={overallBtn["tips"]}
          history={(path) => {
            history.push(
              `/app/LifetimeCount/${path}${title ? "/" + title + "/" + id : ""}`
            );
          }}
          image={index === 3 ? Images.black_tip : Images.tip_ico}
        />
        <AnalyticsBtn
          index={4}
          activeIndex={index}
          onClick={(i) => setIndex(i)}
          play={overallBtn["listen"]}
          history={(path) => {
            history.push(
              `/app/LifetimeCount/${path}${title ? "/" + title + "/" + id : ""}`
            );
          }}
          image={index === 4 ? Images.black_stream : Images.stream_ico}
        />
        {/* <AnalyticsBtn
          index={5}
          activeIndex={index}
          onClick={(i) => setIndex(i)}
          share={2000}
          history={(path) => {
            history.push(
              `/app/LifetimeCount/${path}${title ? "/" + title + "/" + id : ""}`
            );
          }}
          image={index === 5 ? Images.black_share : Images.share_ico}
           /> */}
        <AnalyticsBtn
          index={6}
          activeIndex={index}
          onClick={(i) => setIndex(i)}
          follow={overallBtn["followers"] !== 0 ? overallBtn["followers"] : "0"}
          history={(path) => {
            history.push(
              `/app/LifetimeCount/${path}${title ? "/" + title + "/" + id : ""}`
            );
          }}
          image={index === 6 ? Images.black_follow : Images.follow}
        />
      </Stack>
      <Box axis={theme.direction === "rtl" ? "x-reverse" : "x"} index={value}>
        <TabPanel value={value} index={value} dir={theme.direction}>
          <Stack>
            <Box>
              <Stack spacing={1} sx={{ position: "relative" }}>
                <Stack
                  sx={{ padding: "0 18px" }}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography className="fs-24 fade-text50">
                    {tab == "Views"
                      ? t("analytics.tabs.tab1")
                      : tab === "Tips"
                      ? t("analytics.tabs.tab2")
                      : tab === "Streams"
                      ? t("analytics.tabs.tab3")
                      : tab === "Follow"
                      ? t("analytics.tabs.tab4")
                      : null}
                  </Typography>
                  <Stack
                    direction="row"
                    alignItems="center"
                    className="_cp"
                    onClick={() => setOpen(!open)}
                  >
                    <Typography className="fs-13 _cp">
                      {selectedTime}
                    </Typography>
                    <KeyboardArrowDownIcon color="default" />
                  </Stack>
                </Stack>
                {open ? (
                  <OutsideClickHandler onOutsideClick={() => setOpen(false)}>
                    <ProfileMenu
                      right={"0px"}
                      actions={[
                        { key: "m17", action: t("dropMenu.m17") },
                        { key: "m18", action: t("dropMenu.m18") },
                        { key: "m19", action: t("dropMenu.m19") },
                        { key: "m20", action: t("dropMenu.m20") },
                      ]}
                      handleProfileMenuChoice={(action, index) =>
                        toggleDrawer(action, index)
                      }
                    />
                  </OutsideClickHandler>
                ) : null}
                {/* {lifeTimeCount["graph"] && lifeTimeCount["graph"].length > 0 ? (
                <AreaGraph graph={lifeTimeCount["graph"]} />
              ) : null} */}
                {/* <div
                  className="Grid"
                >
                  <div>
                    <AreaGraph
                      graph={lifeTimeCount["graph"]}
                      className="__analytic_card"
                    />
                    <BarGraph className="__analytic_card" />
                  </div>
                  <div>
                    <Map className="__analytic_card main" main={main} />
                  </div>
                  <div>
                    <PieChart
                      lifeTimeCount={lifeTimeCount["genderClassification"]}
                      id="gender"
                      className="__analytic_card"
                    />
                  </div>
                  <div>
                    <PieChart
                      lifeTimeCount={lifeTimeCount["ageClassification"]}
                      id="age"
                      className="__analytic_card"
                    />
                  </div>
                </div> */}
                {/* <Map className="__analytic_card" padd={padd} /> */}
                {/* <AllMusicViews /> */}
                {/* <AllMusicTips /> */}

                {tab && !title ? (
                  <>
                    {
                      // tab === "Views" ? (
                      //   <AllMusicViews
                      //     selectedTime={selectedTime}
                      //     selectedKey={selectedKey}
                      //     tab={tab}
                      //     data={overallBtn}
                      //     location={location}
                      //     gender={gender}
                      //     graph={graph}
                      //     age={age}
                      //   />
                      // ) :
                      tab === "Tips" ? (
                        <AllMusicTips
                          selectedTime={selectedTime}
                          selectedKey={selectedKey}
                          tab={tab}
                          data={overallBtn}
                          location={location}
                          gender={gender}
                          graph={graph}
                          age={age}
                          currency={currency}
                          tip={overallBtn["tips"]}
                        />
                      ) : tab === "Streams" ? (
                        <AllmusicStreams
                          selectedTime={selectedTime}
                          selectedKey={selectedKey}
                          tab={tab}
                          location={location}
                          gender={gender}
                          graph={graph}
                          age={age}
                        />
                      ) : tab === "Follow" ? (
                        <AllMusicFollow
                          selectedTime={selectedTime}
                          selectedKey={selectedKey}
                          tab={tab}
                          location={location}
                          gender={gender}
                          graph={graph}
                          age={age}
                        />
                      ) : null
                    }
                  </>
                ) : (
                  <>
                    {
                      // tab === "Views" ? (
                      //   <MusicViews
                      //     // selectedTime={selectedTime}
                      //     selectedKey={selectedKey}
                      //     tab={tab}
                      //     data={overallBtn}
                      //     location={location}
                      //     gender={gender}
                      //     graph={graph}
                      //     age={age}
                      //   />
                      // ) :
                      tab === "Tips" ? (
                        <MusicTips
                          selectedTime={selectedTime}
                          selectedKey={selectedKey}
                          tab={tab}
                          data={overallBtn}
                          location={location}
                          gender={gender}
                          graph={graph}
                          age={age}
                          currency={currency}
                          tip={overallBtn["tips"]}
                        />
                      ) : tab === "Streams" ? (
                        <MusicStreams
                          selectedTime={selectedTime}
                          selectedKey={selectedKey}
                          location={location}
                          gender={gender}
                          graph={graph}
                          age={age}
                          tab={tab}
                        />
                      ) : tab === "Follow" ? (
                        <MusicFollow
                          selectedTime={selectedTime}
                          selectedKey={selectedKey}
                          location={location}
                          gender={gender}
                          graph={graph}
                          age={age}
                          tab={tab}
                        />
                      ) : null
                    }
                  </>
                )}

                {/* {tab === "music"?  <MusicViews/> : null} */}
                {/* <MusicViews/> */}
              </Stack>
            </Box>
          </Stack>
        </TabPanel>
      </Box>
      {/* <BottomSheet
        open={open}
        actions={[
          t("dropMenu.text17"),
          "Last 7 days",
          "Last 28 days (4 weeks)",
          "Last 365 days",
        ]}
        handleOpen={toggleDrawer}
      /> */}
      {loading ? <Loader /> : null}
    </Box>
  );
}
